module.exports = __webpack_public_path__ + "static/media/debit-card.b31cb0e6.svg";